const activities = [
  // {
  //   id: 'Hiking',
  //   url: '/hiking',
  //   title: 'Hiking from Fuglafjørð to Skarðið',
  //   //position: [16, .8, -85],
  //   position: [340, 3.2, 62],
  //   translation_key: 'hiking',
  //   image_url: '',
  //   location: 'Reinsaríið Torshavn.',
  // },
  // {
  //   id: 'Kayaking',
  //   url: '/kayaking',
  //   title: 'Kayaking in Fuglafjørður',
  //   position: [333, 1.2, 67],
  //   translation_key: 'kayaking',
  //   image_url: '',
  //   location: 'Reinsaríið Torshavn.',
  // },
  // {
  //   id: 'Fishing',
  //   url: '/fishing',
  //   title: 'Fishing trip',
  //   position: [334, 2.1, 62],
  //   translation_key: 'fishing',
  //   image_url: '',
  //   location: 'Reinsaríið Torshavn.',
  // },
  {
    id: 'Saturday Hiking',
    url: '/hiking',
    title: 'Hiking to ancient cultural centre Kirkjubøur',
    mapTitle: 'Hiking',
    position: [54.3, 3, 81.3],
    translation_key: 'fishing',
    location: '',
  },
  {
    id: 'Saturday Fishing',
    url: '/fishing',
    title:'Fishing and cooking in Vestmanna',
    mapTitle: 'Fishing',
    position: [253, 4, -96],
    translation_key: 'fishing',
    location: 'Vestmanna',
  },
  {
    id: 'Saturday Motorcycle trip',
    url: '/motorcycle-trip',
    title: 'Motorcycle trip from Torshavn to Tjørnuvík, via Saksun',
    mapTitle: 'Motorcycle trip',
    position: [116.3, 1.5, 94.3],
    location: '',
  },
  {
    id: 'Saturday Racing Bike',
    url: '/racing-bike',
    title: 'Explore the Faroe Island on a racing bike',
    mapTitle: 'Racing Bike',
    position: [114.3, 5.5, 88.3],
    translation_key: 'fishing',
    location: '',
  },
  {
    id: 'Saturday Kayaking',
    url: '/kayaking',
    title: 'Kayaking on the lake above the ocean',
    mapTitle: 'Kayaking',
    position: [145, 4, -122],
    location: '',
  },
  {
    id: 'Horseback riding',
    url: '/horseback-riding',
    title: 'Get a glimpse of the everyday life',
    mapTitle: 'Horseback riding',
    position: [98, 3.5, 72],
    translation_key: 'fishing',
    location: '',
  },
  {
    id: 'peturlarsenfriday',
    url: '/petur-larsen',
    title: 'Full program',
    mapTitle: 'Full program',
    position: [336, 6, 62],
    alternative: 'yes'
  }
]

export default activities
